import { makeAutoObservable } from 'mobx';
import { toast } from 'react-toastify';
import { LabelService } from '../services';
import IAreaLabel from '../types/AreaLabel';

export default class LabelStore {
    error: any;

    areaLabels: IAreaLabel[] = [];

    private labelService: typeof LabelService;

    constructor() {
        this.labelService = LabelService;
        makeAutoObservable(this);
    }

    private setError(error: any): void {
        // eslint-disable-next-line no-console
        console.error(error);
        this.error = error;
        toast.error(error.message);
    }

    private setAreaLabelsForSession(areaLabels: IAreaLabel[]) {
        this.areaLabels = areaLabels;
    }

    async addAreaLabels(
        userEmail: string,
        sessionName: string,
        areaLabels: IAreaLabel[],
    ): Promise<void> {
        try {
            await this.labelService.addLabels(
                userEmail,
                sessionName,
                areaLabels,
            );
            this.setAreaLabelsForSession(areaLabels);
        } catch (error) {
            this.setError(error);
        }
    }

    async fetchAreaLabels(
        userEmail: string,
        sessionName: string,
    ): Promise<void> {
        try {
            const labels = await this.labelService.fetchLabels(
                userEmail,
                sessionName,
            );
            this.setAreaLabelsForSession(labels);
        } catch (error) {
            this.setError(error);
        }
    }

    async deleteAreaLabels(
        userEmail: string,
        sessionName: string,
    ): Promise<void> {
        try {
            await this.labelService.deleteLabels(userEmail, sessionName);
            this.setAreaLabelsForSession([]);
        } catch (error) {
            this.setError(error);
        }
    }
}
